export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE'
export const SET_CURRENT_TITLE = 'SET_CURRENT_TITLE'
export const SET_DESCRIPTION = 'SET_DESCRIPTION'
export const SET_GRAPH_TYPE = 'SET_GRAPH_TYPE'
export const SET_GRAPH_VALUES = 'SET_GRAPH_VALUES'
export const SET_GRAPH_VALUE_NAME = 'SET_GRAPH_VALUE_NAME'
export const SET_GRAPH_VALUE_ATTRIBUTES = 'SET_GRAPH_VALUE_ATTRIBUTES'
export const SET_GRAPH_ERRORS = 'SET_GRAPH_ERRORS'
export const SET_MAXIMUM_VALUES = 'SET_MAXIMUM_VALUES'
export const SET_MINIMUM_VALUES = 'SET_MINIMUM_VALUES'
export const SET_FREQUENCY = 'SET_FREQUENCY'
export const SET_PRIOR_YEARS = 'SET_PRIOR_YEARS'
export const SET_YEAR_TYPE = 'SET_YEAR_TYPE'
export const SET_XAXIS_RANGE = 'SET_XAXIS_RANGE'
export const SET_OLD_GRAPH_PERIODS = 'SET_OLD_GRAPH_PERIODS'
export const SET_GRAPH_ENDPOINTS = 'SET_GRAPH_ENDPOINTS'
export const UPDATE_PREVIEW_DATA = 'UPDATE_PREVIEW_DATA'
export const UPDATE_PREVIEWING_STATE = 'UPDATE_PREVIEWING_STATE'
export const SET_PREVIEW_ERROR = 'SET_PREVIEW_ERROR'
export const UPDATE_SAVING_STATE = 'UPDATE_SAVING_STATE'
export const SET_DRAWER_SETUP = 'SET_DRAWER_SETUP'
export const UPDATE_DRAWER_SAVING_STATE = 'UPDATE_DRAWER_SAVING_STATE'
export const SET_DRAWER_PENDING = 'SET_DRAWER_PENDING'
export const SET_DRAWER_CONFIRMING_REPLACE = 'SET_DRAWER_CONFIRMING_REPLACE'
export const SET_SAVED_GRAPH_PAYLOAD = 'SET_SAVED_GRAPH_PAYLOAD'
